// extracted by mini-css-extract-plugin
export default {"shares":"shares--yRi4M","share-btn":"share-btn--hZTjy","shareBtn":"share-btn--hZTjy"};